module.exports = __webpack_public_path__ + "static/media/github-logo.bb508e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/github-logo.png
// module id = 158
// module chunks = 0